<template>
  <v-card class="mb-4">
    <ValidationObserver ref="observer">
      <v-form>
        <v-card-title
          ><v-icon left>mdi-car-coolant-level</v-icon>
          {{ tank.tankName }}</v-card-title
        >
        <v-row>
          <v-col cols="12" sm="7" class="text-start py-0">
            <v-card-subtitle class="py-0 text-subtitle-1">
              Last Recorded:
              {{
                currentTankStatusDateTimeLt
                  | removeTAndSecondsAndFormatDate
              }}
            </v-card-subtitle>
            <v-card-subtitle
              v-text="getTankStatusString(tank)"
            ></v-card-subtitle>

            <!--<v-card-subtitle
              v-if="isEdit && !isCurrentStatusEdit"
              class="info--text pt-0"
            >
              <v-icon small color="info">mdi-information</v-icon>
              Any edits to this consumption will <strong>not</strong> alter the
              resulting tank status
            </v-card-subtitle>

            <v-card-subtitle
              v-if="isCurrentStatusEdit"
              class="warning--text pt-0"
            >
              <v-icon small color="warning">mdi-alert</v-icon>
              Editing will alter the current tank status. Please
              <strong>delete</strong> and <strong>re-enter</strong> this
              consumption
            </v-card-subtitle>-->
          </v-col>
          <v-col cols="12" sm="5" class="py-0 px-8 mt-4 mt-sm-0">
            <v-row justify="end">
              <v-col cols="12" class="py-0">
                <!--<ValidationProvider
                  v-slot="{ errors }"
                  name="Bulk Quantity"
                  :rules="quantityValidationRule"
                >-->
                  <v-text-field
                    class="py-0"
                    type="number"
                    step="0.1"
                    v-model="tank.transaction.quantity"
                    label="Quantity"
                    :suffix="tank.qtyUom"
                  ></v-text-field>
                <!--</ValidationProvider>-->
              </v-col>
            </v-row>
            <v-row justify="space-between">
              <v-col cols="6" class="py-0">
                <!--<v-checkbox
                  v-model="transaction.isTankUpdate"
                  label="Update Tank"
                  :disabled="isEdit"
                ></v-checkbox>-->
              </v-col>
              <v-col cols="6" class="py-2" align-self="center">
                <v-row justify="end">
                  <v-btn
                    v-if="!transaction.id && !transaction.idc"
                    color="primary"
                    @click="submitClicked(false)"
                    small
                    :loading="isSubmitting"
                    >Submit</v-btn
                  >
                  <v-btn
                    v-else
                    color="primary"
                    @click="submitClicked(true)"
                    small
                    :disabled="
                      !isClientConnectedToServer || isCurrentStatusEdit
                    "
                    :loading="isSubmitting"
                    >Edit</v-btn
                  >
                  <v-icon
                    class="ml-2"
                    :disabled="!isEdit"
                    @click="showDeleteDialog = true"
                    >mdi-delete</v-icon
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </ValidationObserver>
    <confirm-dialog
      v-model="showDeleteDialog"
      title="Delete Consumption"
      description="Are you sure you want to delete this consumption?"
      :onCloseClick="closeDeleteDialog"
      :onConfirmClick="onDeleteClick"
    />
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import BulkTransactionsHelpersMixin from '../../mixins/BulkTransactionsHelpersMixin';
import ConfirmDialog from '../ui/ConfirmDialog.vue';

export default {
  name: 'TankConsumptionForm',
  props: {
    tank: Object,
    transaction: Object,
    onSubmit: Function,
    onSubmitEdit: Function,
    onDelete: Function,
  },
  mixins: [BulkTransactionsHelpersMixin],
  components: {
    ValidationProvider,
    ValidationObserver,
    ConfirmDialog,
  },
  data() {
    return {
      showDeleteDialog: false,
      isSubmitting: false,
    };
  },
  computed: {
    ...mapGetters({
      isClientConnectedToServer: 'userStore/isClientConnectedToServer',
    }),
    currentTankStatus() {
      return this.tank.currentTankStatus;
    },
    currentTankStatusDateTimeLt() {
      if (this.currentTankStatus)
        return this.tank.currentTankStatus.statusDateTimeLt;

      return null;
    },
    isEdit() {
      return !!this.transaction.id || !!this.transaction.idc;
    },
    isCurrentStatusEdit() {
      let isCurrentStatusEdit = false;

      // If the current tank status is linked to this consumption
      if (this.isEdit && this.currentTankStatus) {
        isCurrentStatusEdit = this.currentTankStatus.bulkTransactionId === this.transaction.id;
      }

      return isCurrentStatusEdit;
    },
    consumptionQuantityRule() {
      return {
        required: true,
        validDeliveryQuantity: {
          currentQuantity: this.currentTankStatus?.quantityOnBoard ?? 0,
          qtyUom: this.tank.qtyUom,
        },
      };
    },
    quantityRule() {
      return {
        required: true,
        validQuantity: {
          maxCapacity: this.tank.maxCapacity,
          qtyUom: this.tank.qtyUom,
        },
      };
    },
    quantityValidationRule() {
      if (this.isEdit) return this.quantityRule;
      return this.consumptionQuantityRule;
    },
  },
  methods: {
    submitClicked(isEdit) {
      this.$refs.observer.validate()
        .then((isValid) => {
          if (isValid) {
            this.isSubmitting = true;

            if (isEdit) {
              this.onSubmitEdit(this.tank, this.transaction)
                .finally(() => { this.isSubmitting = false; });
            } else {
              this.onSubmit(this.tank, this.transaction)
                .finally(() => { this.isSubmitting = false; });
            }
          }
        });
    },
    getTankStatusString(tank) {
      if (!tank || !tank.currentTankStatus)
        return "";

      return `${tank.currentTankStatus.bulk}: ${tank.currentTankStatus.quantityOnBoard}/${tank.maxCapacity} ${tank.qtyUom}`;
    },
    onDeleteClick() {
      this.onDelete(this.tank, this.transaction)
        .then(this.closeDeleteDialog());
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false;
    },
  },
};
</script>
